export { Icon, type IconProps } from "@visioni/a3s-ui/components";
export type { IconName as IconNameType } from "@visioni/a3s-ui/icons";
